export enum IntegrationTypeEnum {
    Site = 0,
    Email = 1,
    FTP = 2
}